import React, { ErrorInfo } from 'react';
import { withRouter } from 'react-router';
import { ErrorComp } from './ErrorComp';
import { nsKdevKimUser } from '../../../remote/kdev';
import { errorHandleConfig } from './UploadError';
import { handleErrorReLoad, PAGE_ERROR_RELOAD_INFO } from './HandleLoadError';

interface IState {
    hasError: boolean;
    error: Error | null;
}

/**
 * e.g: 截取当前路径，如当前路径为：/web/workbench/branchView。截取后为：/web/workbench。 该方法用来匹配对应路径下的oncall人员。用法见：loadOncallList
 * {"path": ["/web/workbench","/web/gitlab","/web/test-mgr"],"name": "彭钟玲","userName": "pengzhongling", "avatar": ""}
 * 数据中的path含有/web/workbench，就会返会此匹配项的oncall人员：彭钟玲。
 */
const pathPre = location.pathname.slice(0, nthIndexOf(location.pathname, '/', 2));
function nthIndexOf(str: string, target: string, no: number) {
    let x = str.indexOf(target);
    for (let i = 0; i < no; i++) {
        x = str.indexOf(target, x + 1);
    }
    return x < 0 ? str.length : x;
}
export function withKDevPageError(Component) {

    class WithErrorHandler extends React.Component<any & {oncallList: Array<{name: string; username: string}>}, IState> { // long
        public unListen: any;
        constructor(props) {
            super(props);
            this.state = {
                hasError: false,
                // 错误信息，是否需要展示出来呢？
                error: null,
            };
        }
        public componentDidMount(): void {
            this.unListen = this.props.history.listen(() => {
                const storage_reload_info = localStorage.getItem(PAGE_ERROR_RELOAD_INFO);
                // 缓存里的刷新信息
                const page_error_reload_info = storage_reload_info ? JSON.parse(storage_reload_info) : null;
                if (location.pathname !== page_error_reload_info?.hasReloadPath) {
                    this.setState({hasError: false});
                }
            });
        }
        public componentWillUnmount(): void {
            this.unListen();
        }

        public componentDidCatch(error, info) {
            // 只有当强制刷新无效时才展示联系oncall人员，上报此类错误
            const needShowOnCallUser = handleErrorReLoad();
            this.setState({ hasError: needShowOnCallUser});
            // 监控上报错误
            if (needShowOnCallUser) {
                errorHandleConfig.uploadPageError(error);
            }
        }
        public async loadOncallList() {
            try {
                const respData = await nsKdevKimUser.remote({});
                let oncallList = respData.errorOncallList.filter(item =>
                    item.path.findIndex(it => location.pathname.indexOf(it) > -1) > -1
                ).map(user => {
                    return {
                        name: user.name,
                        username: user.userName
                    };
                });
                // 兜底显示
                if (oncallList.length === 0) {
                    oncallList = [{
                        name: '陈新华',
                        username: 'wb_chenxinhua'
                    }];
                }
                return Promise.resolve(oncallList);
            } catch (e) {
                return Promise.resolve([]);

            }
        }

        public render() {
            if (this.state.hasError) {
                return (
                       <ErrorComp
                           onSearchOnCallUser={this.props.oncallList ? undefined : this.loadOncallList}
                           oncallList={this.props.oncallList}
                           chunkLoadErrorVisible={
                               !!this.state.error && this.state.error?.name.includes('ChunkLoadError')
                           }
                       />
                );
            }
            return <Component {...this.props} />;
        }
    }
    return withRouter(WithErrorHandler);
}

withKDevPageError.errorHandleConfig = errorHandleConfig;
